<template>
    <div class="login">
        <div class="columns">
            <div class='column is-4 is-offset-4'>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <form>
                    <div class='column is-horizontal-center top-logo'>
                          <figure class='image'>
                            <img src="../../assets/images/lango.png">
                        </figure>
                    </div>
                    <div v-show="! showTokenExpiredMessage">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p class="reset-heading">Choose a new password</p>
                        </div>
                        <div class="field">
                            <label>Password</label>
                            <div class="control has-icons-left">
                                <input class="input is-medium" v-bind:class="{ 'is-danger': passwordErr }" type="password" placeholder="Password" v-model="password" @focus="clearErrorMsgs">
                                <span class="icon is-small is-left">
                                    <icon name="key"></icon>
                                </span>
                            </div>
                            <p v-if="passwordErr" class="help is-danger is-danger-password">Password is required</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <label>Confirm Password</label>
                            <div class="control has-icons-left">
                                <input class="input is-medium" v-bind:class="{ 'is-danger': confirmPasswordErr }" type="password" placeholder="Confirm Password" v-model="confirmPassword" @focus="clearErrorMsgs" @keyup="checkValue($event.target.value)" @blur="checkValue($event.target.value)">
                                <span class="icon is-small is-left">
                                    <icon name="key"></icon>
                                </span>
                            </div>
                            <p v-show="confirmPasswordErr" class="help is-danger is-danger-password"><img width="20" src="../../assets/images/error.png"/> Password do not match</p>
                            <p v-show="passwordMatch" class="help is-success"><img width="20" src="../../assets/images/success.png"/> Matched</p>
                        </div>
                        <div class="field" style="margin-top: 25px;">
                            <button @click.prevent="savePassword" class="button is-link login-link" v-bind:class="{ 'is-loading': isLoading}" :disabled="! canSavePassword">Save</button>
                        </div>
                        <div class="field">
                            <div class="password-reset">
                                <p class="back-to-login" v-on:click="returnToLogin">Back to Login</p>
                            </div>
                        </div>
                    </div>
                    <div v-show="showTokenExpiredMessage">
                        <div class="password-reset" style="margin-bottom: 25px;">
                            <p><img src="../../assets/images/error.png"/></p>
                            <p style="font-size: 20px; font-weight: bold;">Token Expired</p>
                            <br/>
                            <p style="font-size: 16px;">
                                Your password reset token has expired.
                            </p>
                        </div>
                        <div class="field">
                            <div class="password-reset">
                                <p class="back-to-login" v-on:click="returnToLogin">Back to Login</p>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            password: '',
            confirmPassword: '',
            passwordMatch: false,
            passwordErr: false,
            confirmPasswordErr: false,
            canSavePassword: false,
            token: '',
        }
    },
    
    computed: {
        ...mapState('passwordReset', {
            isLoading: state => state.isLoading,
            showTokenExpiredMessage: state => state.showTokenExpiredMessage,
            resetPasswordErrMessage: state => state.resetPasswordErrMessage,
        })
    },

    methods: {
        savePassword(){

            VueStore.dispatch('passwordReset/setBoolean', {key: 'isLoading', bool: true});
            var password = {
                password: this.password,
                token: this.token
            }

            VueStore.dispatch('passwordReset/savePassword', password);
        },

        checkValue(val){
            if(this.password == ''){
                this.passwordErr = true;
            } else if(this.password === val){
                this.passwordMatch = true;
                this.canSavePassword = true;
                this.confirmPasswordErr = false;
            } else {
                this.confirmPasswordErr = true;
                this.passwordMatch = false;
                this.canSavePassword = false;
            }
        },

        returnToLogin(){
            window.location.href = '/login';
        },

        clearErrorMsgs(){
            this.passwordErr = false;
            this.confirmPasswordErr = false;
        },

        fetchData(){
            // this will save the url of client
            VueStore.dispatch('global/getBaseURL');
        },

        prcoessURL(){
            var url_string = window.location.href;
            var url = new URL(url_string);
            var token = url.searchParams.get("token");
            var email = url.searchParams.get("email");

            var data = {
                token: token,
                email: email
            }
            
            // we'll save token for later usage
            this.token = token;

            // delay so auth store is loaded.
            setTimeout(function(){ 
                VueStore.dispatch('passwordReset/checkToken', data);
            }, 500);
        }
    },

    mounted(){
        this.fetchData();
        this.prcoessURL();
        // retrive environment variables and stored in vuex.
        VueStore.dispatch('auth/setVariables');
    }
}
</script>

<style>
</style>